import { render, staticRenderFns } from "./index - 副本.vue?vue&type=template&id=bc77c75e&scoped=true&"
import script from "./index - 副本.vue?vue&type=script&lang=js&"
export * from "./index - 副本.vue?vue&type=script&lang=js&"
import style1 from "./index - 副本.vue?vue&type=style&index=1&id=bc77c75e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc77c75e",
  null
  
)

export default component.exports